import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import VideoRenderer from './Renderer/VideoRenderer'

const videoPlugin = settings =>
    createPlugin({
        Renderer: VideoRenderer,
        ...settings,
    })

const video = videoPlugin()
export default video

export { videoPlugin, VideoRenderer }
